import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import RadiusTableHeaders from "./RadiusTableHeaders";
import "../css/table.css";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export default function RadiusTable({
  radiusData,
  collection,
  defaultFilters,
  filters,
}) {
  const [tableHeaders, setTableHeaders] = useState([]);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const UpdateHeaders = useCallback((headers) => {
    setTableHeaders(headers);
  }, []);

  useEffect(() => {
    if (radiusData) {
      var keys_array = Object.keys(radiusData?.[0]);
      var headers_array = [];
      keys_array.forEach((value) => {
        if (defaultFilters.includes(value) || filters.includes(value)) {
          headers_array.push({
            id: value,
            numeric: false,
            disablePadding: true,
            label: value,
          });
        }
      });
      UpdateHeaders(headers_array);
    }
  }, [filters, defaultFilters, radiusData, UpdateHeaders]);

  useEffect(() => {
    if (radiusData) {
      if (radiusData?.length < page * rowsPerPage) {
        setPage(0);
      }
      var keys_array = Object.keys(radiusData?.[0]);
      if (!tableHeaders.length) {
        var headers_array = [];
        if (radiusData?.length > 0) {
          keys_array.forEach((value) => {
            if (defaultFilters.includes(value) || filters.includes(value)) {
              headers_array.push({
                id: value,
                numeric: false,
                disablePadding: true,
                label: value,
              });
            }
          });
          setTableHeaders(headers_array);
        }
      }
    }
  }, [
    radiusData,
    page,
    rowsPerPage,
    tableHeaders,
    setTableHeaders,
    filters,
    defaultFilters,
  ]);

  useEffect(() => {
    setTableHeaders([]);
  }, [collection]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function cellValueTypograhpy(cell_value) {
    let cell_color = "#001864";
    if (cell_value) {
      if (cell_value.toString().indexOf("redcell") > -1) {
        cell_value = cell_value.replace("redcell", "");
        cell_color = "#e9412e";
      }
    }
    return (
      <Typography
        variant="body2"
        component="div"
        sx={{ flexGrow: 1, color: cell_color }}
      >
        {cell_value}
      </Typography>
    );
  }

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - radiusData?.length) : 0;

  if (radiusData || radiusData?.length) {
    return (
      <Box className="boxtable">
        <TableContainer sx={{ maxHeight: "65vh" }}>
          <Table
            className="generalTable"
            sx={{ minWidth: "100%" }}
            aria-labelledby="tableTitle"
            size={"small"}
            stickyHeader
          >
            <RadiusTableHeaders
              sx={{
                mb: 0,
              }}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={radiusData?.length}
              headCells={tableHeaders}
            />
            <TableBody>
              {radiusData
                .sort(getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  let row_keys_array = Object.keys(row);

                  return (
                    <TableRow hover tabIndex={-1} key={index}>
                      {row_keys_array.map((column_key, column_index) => {
                        if (
                          defaultFilters.includes(column_key) ||
                          filters.includes(column_key)
                        ) {
                          return (
                            <TableCell
                              className={"tablecell"}
                              component="th"
                              id={column_key + column_index}
                              key={column_key + column_index}
                              scope="row"
                              padding="normal"
                            >
                              {cellValueTypograhpy(
                                row?.[column_key] === 0
                                  ? null
                                  : row?.[column_key]
                              )}
                            </TableCell>
                          );
                        }
                        return null;
                      })}
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          className={"pagination"}
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={radiusData?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    );
  } else {
    return null;
  }
}
